import axios from "axios";
import { getCookie , setCookie } from "./commonFunction";

const api = axios.create({
  baseURL: process.env.client_apiEndpoint,
});

// Before each request attach token
api.interceptors.request.use((config) => {
  const token = getCookie("error_monitor_token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

// TOKEN INVALID HANDLING
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;
    console.log(response)
    if (
      response &&
      response.status === 400 &&
      response.data &&
      response.data.message === "Invalid Token"
    ) {
      setCookie("error_monitor_token", "", 0);
      window.location.href = "/error-monitor/login";
    }
    return Promise.reject(error);
  }
);

export default api;
